module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mod"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('img', {
    staticClass: "largeIcon",
    attrs: {
      "src": "/static/img/时间.svg",
      "data-src": "/static/img/时间.svg",
      "alt": "largeIcon"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "info"
  }, [_vm._v("\n    " + _vm._s((_vm.orderStatus === _vm.emkt.ORDER_STATUS_CHECK || _vm.orderStatus === _vm.emkt.ORDER_STATUS_WAIT_PD_TECH_AUDIT) ? '订单已提交技术审核' : '订单已提交课题组审批人审批') + "\n  ")]), _vm._v(" "), (_vm.orderStatus === _vm.emkt.ORDER_STATUS_CHECK || _vm.orderStatus === _vm.emkt.ORDER_STATUS_WAIT_PD_TECH_AUDIT) ? _c('span', {
    staticClass: "summary"
  }, [_vm._v("\n    技术审核预计在"), (new Date().getHours() >= 17 && new Date().getMinutes() >= 30) ? _c('span', [_vm._v("明天")]) : _vm._e(), _vm._v("17:30完成\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submain",
    on: {
      "click": _vm.revert
    }
  }, [_c('span', [_vm._v("\n      返回主页\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "submain-c",
    on: {
      "click": _vm.gotoOrderList
    }
  }, [_c('span', [_vm._v("\n      查看订单\n    ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-200e8843","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_fc/Order/SubmitChecked.vue
// module id = 1564
// module chunks = 8